export default __webpack_public_path__ + "static/media/WhiteCategory.e9837ab6.svg";